import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '@lib/services/auth-service.service';
import { Observable } from 'rxjs';
import { filter, take, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HabilitationGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.authService.userHabilitationCheck.pipe(
      filter(value => value),
      take(1),
      map(() => {
        // User has no habilitations at all (junior)
        if (this.authService.userConsultantHasNoHabilitations()) {
          return this.router.createUrlTree(['/unauthorized'], {
            queryParams: { reason: 'missing' },
          });
        }

        // User has his habilitations expired
        if (this.authService.userConsultantHasAllHabilitationsExpired()) {
          return this.router.createUrlTree(['/unauthorized'], {
            queryParams: { reason: 'expired' },
          });
        }

        // User has not the required habilitations for the app
        if (this.authService.userConsultantHasNoRequiredHabilitations()) {
          return this.router.createUrlTree(['/unauthorized'], {
            queryParams: { reason: 'missingRequired' },
          });
        }

        return true;
      })
    );
  }
}
